export default "__VITE_ASSET__BAR4S1qR__"